import { useEffect, useCallback } from 'react';
import { useCarOperations } from './useCarOperations';
import { useIsAllowGetCarEBoxLocations } from './useIsAllowGetCarEBoxLocations';
import {
  useCallbackReduxAsyncThunkRetry,
  useCallbackFetchRetry
} from 'shared/hooks';

import dataSources from 'dataSources';

export const useInitCarEBoxDashboardData = () => {
  const fetchCarEBoxDashboardData = useCallback((obuNumber: string) => dataSources.cars.getCarEBoxDashboardData(obuNumber), []);
  const { getCarEBoxLocations, updateCarEBoxDashboardData } = useCarOperations();
  const isAllowGetCarEBoxLocations = useIsAllowGetCarEBoxLocations();
  const getCarEBoxLocationsRetry = useCallbackReduxAsyncThunkRetry(getCarEBoxLocations, 5);
  const getCarEBoxDashboardDataRetry = useCallbackFetchRetry(fetchCarEBoxDashboardData, 5);

  useEffect(() => {
    const execute = async () => {
      try {
        const carEBoxLocations = await getCarEBoxLocationsRetry();

        if (!carEBoxLocations.payload.error) {
          const obuSerialNumbers = carEBoxLocations.payload.map(({ obuNumber }) => obuNumber);

          const carsEBoxDashboardData = await Promise.allSettled(
            obuSerialNumbers.map(obuNumber => getCarEBoxDashboardDataRetry(obuNumber))
          );

          const carEBoxDashboardData = carsEBoxDashboardData.reduce((acc, item, index) => {
            if (item.value) {
              acc.push({
                ...item.value,
                obuNumber: obuSerialNumbers[index]
              });
            }
            
            return acc;
          }, [] as EBoxDashboardData[]);

          updateCarEBoxDashboardData(carEBoxDashboardData);
        }
      } catch (e) {}
    };

    if (isAllowGetCarEBoxLocations) {
      execute();
    }
  }, [
    isAllowGetCarEBoxLocations,
    getCarEBoxLocationsRetry,
    getCarEBoxDashboardDataRetry,
    updateCarEBoxDashboardData
  ]);
};
